// extracted by mini-css-extract-plugin
export default {"component":"page_component__FSC1Q","subtitle":"page_subtitle__mvmHd"};